export default "__VITE_ASSET__0723af8c__"